import React from "react";
import { AuthContext } from "../context/AuthContext";
/**
 * AuthContextを使用するカスタムフック
 *
 * @returns AuthContextの値
 * @throws AuthProvider外で呼び出された場合にエラーをスロー
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const { user, login, logout } = useAuth();
 *
 *   if (!user) {
 *     return <LoginForm />;
 *   }
 *
 *   return <div>Welcome, {user.user_name}!</div>;
 * }
 * ```
 */
export function useAuth() {
    const context = React.useContext(AuthContext);
    // SSR環境またはAuthProvider外で呼び出された場合のフォールバック
    // Astroのclient:only="react"でもVite SSRバンドル生成時にこのコードが評価されるため、
    // エラーを投げる代わりにローディング状態を返す
    if (!context) {
        // SSR検出: windowがundefinedの場合はサーバーサイド
        if (typeof window === "undefined") {
            // SSR時はローディング状態のダミーを返す（実際には使用されない）
            return {
                user: null,
                isAuthenticated: false,
                isLoading: true,
                login: async () => {
                    throw new Error("Cannot login during SSR");
                },
                logout: async () => {
                    throw new Error("Cannot logout during SSR");
                },
                refreshToken: async () => {
                    throw new Error("Cannot refresh token during SSR");
                },
                passkeyEnabled: false,
                signInWithPasskey: async () => {
                    throw new Error("Cannot sign in with passkey during SSR");
                },
                registerPasskey: async () => {
                    throw new Error("Cannot register passkey during SSR");
                },
            };
        }
        // クライアントサイドでAuthProvider外の場合はエラー
        throw new Error("useAuth must be used within AuthProvider");
    }
    return context;
}
